import React from "react";
import Modal from "react-modal";
import axios from "axios";
import styled from "styled-components";

import CloseIcon from "../../../assets/icons/close.svg";
import { ReactComponent as ArrowNextWhite } from "../../../assets/icons/arrowNextWhite.svg";
import { ReactComponent as Error } from "../../../assets/icons/error.svg";

import StyledModal from "../../common/Modal/StyledModal";
import APIVariables from "../../../services/api-variables";
import LocalStorage from "../../../shared/localStorage";
import { useParams } from "react-router-dom";

import { initialValues, validationSchema } from "./config";
import { useFormik } from "formik";
import { handleCatch, isObject } from "../../../shared/helpers";
import { errorMessages } from "../../../constants/errorMessages.constants";

const ConfirmationModal = ({
  statePAFModal,
  closeConfirmationModal,
  message,
  setErrorMessage,
  setIsButtonDisabled,
}) => {
  let customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "37%",
    },
  };

  const { pafID } = useParams();

  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  const catchValidation = (error) => {
    handleCatch(error);

    const errors = error?.response?.data;
    if (typeof errors === "string") {
      setErrorMessage([errorMessages.INTERNAL_SERVER_ERROR]);
    } else {
      const errorsArray = [];
      if (!!errors) {
        Object.keys(errors).forEach((key) => {
          if (isObject(errors[key])) {
            Object.keys(errors[key]).forEach((secondKey) => {
              errorsArray.push(key + " - " + errors[key][secondKey][0]);
            });
          } else {
            errorsArray.push(key + " - " + errors[key]);
          }
        });
        setErrorMessage(errorsArray);
      } else {
        setErrorMessage([error.message]);
      }
    }
  };

  const { values, handleChange, handleSubmit, errors } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      setIsButtonDisabled(true);
      let res;

      if (message.state === 3) {
        res = await axios
          .put(
            process.env.REACT_APP_BASE_URL +
              APIVariables.PRESCRIPTIONS_ACCEPT +
              pafID,
            {
              confirmation_name: values.value,
            },
            {
              headers: {
                Authorization: parseLocalStorage.token,
              },
            }
          )
          .catch(function (error) {
            catchValidation(error);
          });

        if (res?.status === 200) {
          document.dispatchEvent(new CustomEvent("fetchNotificationsCount"));
          closeConfirmationModal();
        }
      } else if (message.state === 2) {
        res = await axios
          .put(
            process.env.REACT_APP_BASE_URL +
              APIVariables.PRESCRIPTIONS_REJECT +
              pafID,
            {
              rejection_reason: values.value,
            },
            {
              headers: {
                Authorization: parseLocalStorage.token,
              },
            }
          )
          .catch(function (error) {
            catchValidation(error);
          });

        if (res?.status === 200) {
          document.dispatchEvent(new CustomEvent("fetchNotificationsCount"));
          closeConfirmationModal();
        }
      }
    },
  });

  const mediaMatch = window.matchMedia("(max-width: 850px)");
  mediaMatch.matches === true
    ? (customStyles.content = {
        ...customStyles.content,
        width: "70%",
      })
    : (customStyles.content = {
        ...customStyles.content,
        width: "37%",
      });

  return (
    <StyledModal>
      <Modal
        isOpen={statePAFModal}
        onRequestClose={closeConfirmationModal}
        style={customStyles}
        contentLabel="Confirmation Modal"
        overlayClassName="overlay-modal"
        shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
      >
        <button onClick={closeConfirmationModal} className="close-icon-button">
          <img src={CloseIcon} alt="Close Icon" />
        </button>
        <div className="wrapper-modal">
          <div className="image">
            {message.type === "error" ? <Error /> : ""}
          </div>
          <div
            className={
              message.type === "error" ? "main-text-error" : "main-text "
            }
          >
            {message.title}
          </div>
          {message.description.length > 0 && (
            <div
              className="second-text"
              dangerouslySetInnerHTML={{
                __html: message.description,
              }}
            />
          )}

          {message.state === 3 && (
            <ConfirmationModal.Container>
              <label htmlFor={"confirmation_name"}>
                Please insert your name:
              </label>
              <input
                type="text"
                onChange={handleChange("value")}
                name="confirmation_name"
                id={"confirmation_name"}
                value={values.value}
                placeholder={"Insert your name"}
              />
            </ConfirmationModal.Container>
          )}

          {message.state === 2 && (
            <ConfirmationModal.Container>
              <input
                type="text"
                onChange={handleChange("value")}
                name="reason_rejection_input"
                id={"reason_rejection_input"}
                value={values.value}
                placeholder={"Type the reason"}
              />
            </ConfirmationModal.Container>
          )}
          <div>
            {errors.value && (
              <span className="input-rejection-error">{errors.value}</span>
            )}
          </div>
        </div>
        <div className="wrapper-buttons">
          <button className="cancel mr-6" onClick={closeConfirmationModal}>
            Cancel
          </button>
          <button
            className={message.type === "error" ? "red-button" : "green-button"}
            onClick={handleSubmit}
          >
            {message.buttonText} <ArrowNextWhite />
          </button>
        </div>
      </Modal>
    </StyledModal>
  );
};

ConfirmationModal.Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > label {
    color: #00594c;
    font-size: 13px;
    margin-bottom: 2px;
  }
  > input {
    width: 100%;
    padding: 1rem;
    background-color: #f0f0f0;
    border: none;

    &:focus {
      outline: none;
    }
  }
`;

export default ConfirmationModal;
